module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-3-8"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("CHAPTER 8")])])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "89599.png",
      "src": "OEBPS/image/89599.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I purchased a lovely bouquet of red roses that would show up nicely in the snow. Maggie thought I was nuts to visit the cemetery in such snowy weather. However, Maggie would remember how disturbed I was when I got the word about Sandra’s suicide. I’ll never forget the day. Maggie and I were having lunch at the Taste restaurant when Noreen called to tell me she had found Sandra bleeding from self-inflicted cuts. By the time I rushed to the hospital, James had her taken away to the funeral home to be cremated immediately. As we entered the cemetery, I drove slowly as I tried to remember Noreen’s instructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, my goodness! Look how old and elaborate some of these gravestones are,” Maggie exclaimed. “It is so picturesque against the starkness of the white snow. I feel badly that I haven’t come here very often to visit my parents’ gravesites.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Some families just don’t practice the ritual and my family was one of them. I think we need to park here and look around. I’m not sure we’ll find it because of the snow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("We got out into the bitter cold and soon found that our task was impossible. It was somewhat daunting to stand there and think about all the cold bodies underground. We stood there in silence taking in the quiet scene until the driver of a car going by gave us a suspicious look.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Okay, Kate, we’d better return another time,” Maggie suggested as she hastily got in the car.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I agree. I’m freezing!” As we took the curvy road toward an exit, I wondered if Sandra knew we were there.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh! What about your roses in the back seat?” Maggie remembered.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“They will do nicely for Carla,” I suggested. “She will love them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ll certainly keep her in my prayers tonight,” Maggie said, sounding concerned. “She needs a break.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, it’s weird, because she’s not really sick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“She will be in the future if she needs chemo.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Let’s not jump ahead of ourselves,” I cautioned. “I want to keep things as positive and upbeat as possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Do you want me to sit with you tomorrow?” Maggie offered with a sigh.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“No, that’s not necessary. I’ll call you as soon as I know something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Maggie gave me a big hug when I dropped her off at her car. Before I went back to the condo, I stopped by the grocery store to get some things. I wanted to make Carla some of my blueberry muffins. It was also a way of calming my nerves for what may be ahead. When I got back to the condo, I had to make a couple of trips to get all my bags inside. On the second trip, John pulled up next to me as he parked his car.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Hey, beautiful!” John called out. “Welcome back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("He was so darn cute when he smiled. He got out of his car, gave me a hug, and took the bags from my hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Thanks. How are you?” I said as we walked toward our condos.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Good! It appears you’ll be staying awhile from the looks of all this food.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I hope I don’t, but I only have beer in my refrigerator right now,” I joked. “Carla’s surgery is tomorrow, which is why I’m here, so I hope it goes well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I do too! So, what are you doing tonight?” John asked when we arrived at my door.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Nothing. Just getting settled. I feel like I have a lot to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So, how about I cook some dinner for you?” John offered as he put the groceries on the counter.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That’s not necessary,” I said, shaking my head. “First, I have to get these roses in water and then I bought food that I can make for my dinner.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Okay, we can do this,” he persisted. “I’ll cook us something simple and when it’s ready, I’ll call you to join me. When you’re finished, you can head upstairs to do your chores and get a good night’s sleep.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I had to chuckle at his determination. “Okay. It’s a deal, so now get out of here!” I said, pushing on his chest. He was pleased!")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ll give you a call,” he said, going out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("As I unpacked the groceries, I checked my phone. Ellie had sent me a text asking me to call her. How did I miss that? I poured a glass of orange juice and sat on the couch to make the call. “Ellie, is everything okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I think so,” she answered. “I was hoping you would call me when you arrived. Has Carla had her surgery?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“No, that’s tomorrow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I almost called last night, but I didn’t want to alarm you unnecessarily,” she added.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“What are you saying? Should I be alarmed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, when I came home from the winery last night, your bedroom windows were lit up like it was daylight!” Ellie explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I didn’t respond so she could continue.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So, Kate, when you first moved in, didn’t you tell me about some light that appeared in your bedroom? Is that what I saw?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I took a deep breath. “I suppose so,” I said, giving her questions some thought. “I don’t know why this would happen with no one home. Occasionally, guests would say something, but this happening while the house is empty is puzzling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It bugged me all night,” Ellie complained. “I suppose I should have gone in to check but frankly, I was too scared.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“No. I’m sure everything is fine, Ellie.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It’s Josephine, right?” Ellie asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It’s Josephine or Doc,” I stated with a chuckle. “When she moved all those quilts around after I moved in, I figured she was the active one in the house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I don’t know how you take this so calmly. Aren’t you ever scared?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I actually feel very safe there for some reason. Check again tonight and see if it happens.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, I will! I’m sorry to bother you with this, but I thought you should know. By the way, Sharla Lee and her staff came to the winery yesterday for lunch, and she told me that she has some news for you when you get back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It must be information about Josephine,” I said, feeling excited about the prospect of knowing more about Josephine. “I may have to call her while I’m here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, I have to go, but hurry home, okay? Give Carla my best!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432186cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/everlastingquilts_split10.vue
// module id = 90
// module chunks = 0